export default __webpack_public_path__ + "static/media/FSDillonProRegular.e94d12f3.otf";